import { Fragment } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Clock } from "lucide-react";
import { UPCOMING_MATCHES } from "@/data/teamData";

// Daftar tim untuk satu laga: dukung format trofeo (banyak tim) maupun 1 vs 1.
function MatchTeams({ m }) {
  const teams = m.teams || [m.home, m.away];
  return (
    <div className="font-display text-xl sm:text-2xl flex items-center gap-2 sm:gap-3 flex-wrap">
      {teams.map((t, idx) => (
        <Fragment key={idx}>
          {idx > 0 && <span className="text-[#050B14]/30 text-sm">vs</span>}
          <span
            className={
              t === "The 30s FF"
                ? "text-[#E63946]"
                : t === "Mencari Lawan"
                ? "text-[#050B14]/40 italic text-base sm:text-lg"
                : ""
            }
          >
            {t}
          </span>
        </Fragment>
      ))}
    </div>
  );
}

export default function UpcomingMatches() {
  return (
    <section data-testid="upcoming-matches-section" className="bg-white text-[#050B14] border-t border-[#050B14]/5">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-24">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div>
            <div className="text-xs font-bold tracking-[0.3em] text-[#E63946] mb-3">JANGAN SAMPAI KELEWATAN</div>
            <h2 className="font-display text-5xl sm:text-6xl leading-none">
              JADWAL <span className="text-[#E63946]">LAGA</span>
            </h2>
          </div>
          <a
            href="#kontak"
            data-testid="upcoming-cta-all"
            className="inline-flex w-fit items-center gap-2 bg-[#050B14] hover:bg-[#E63946] text-white px-6 py-3 text-xs font-bold tracking-wider transition-colors"
          >
            AJAK KAMI BERTANDING <ArrowRight size={14} />
          </a>
        </div>

        <div className="divide-y divide-[#050B14]/10 border-y border-[#050B14]/10">
          {UPCOMING_MATCHES.map((m) => (
            <div
              key={m.id}
              data-testid={`upcoming-match-${m.id}`}
              className="flex flex-col gap-3 sm:grid sm:grid-cols-12 sm:items-center sm:gap-4 py-5 group hover:bg-[#050B14]/[0.02] transition-colors px-2"
            >
              {/* Row atas (mobile): tanggal + badge tipe */}
              <div className="flex items-center justify-between gap-3 sm:contents">
                {/* Date */}
                <div className="sm:col-span-2 flex items-center gap-3">
                  <div className="font-display text-3xl sm:text-4xl text-[#E63946] leading-none">
                    {m.date.split(" ")[0]}
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[10px] tracking-[0.2em] text-[#050B14]/60">{m.date.split(" ")[1]}</span>
                    <span className="text-[10px] tracking-[0.2em] text-[#050B14]/40">{m.weekday}</span>
                  </div>
                </div>

                {/* Type */}
                <div className="sm:col-span-2">
                  <span
                    className={`inline-block text-[10px] font-bold tracking-[0.2em] px-2 py-1 ${
                      m.type === "KANDANG"
                        ? "bg-[#E63946]/10 text-[#E63946]"
                        : m.type === "TROFEO"
                        ? "bg-[#E63946] text-white"
                        : m.type === "FRIENDLY"
                        ? "bg-[#050B14] text-white"
                        : m.type === "INTERNAL"
                        ? "bg-[#F4A300]/20 text-[#B87800] border border-[#F4A300]/40"
                        : "bg-[#050B14]/10 text-[#050B14]"
                    }`}
                  >
                    {m.type}
                  </span>
                  <div className="text-[10px] text-[#050B14]/60 mt-1 tracking-wider hidden sm:block">
                    {m.competition}
                  </div>
                </div>
              </div>

              {/* Teams */}
              <div className="sm:col-span-5">
                <MatchTeams m={m} />
              </div>

              {/* Meta */}
              <div className="flex sm:col-span-2 flex-row sm:flex-col sm:items-end gap-4 sm:gap-0 text-xs text-[#050B14]/70">
                <span className="flex items-center gap-1"><Clock size={12} /> {m.time}</span>
                <span className="flex items-center gap-1 sm:mt-1"><MapPin size={12} /> {m.venue}</span>
              </div>

              {/* Desktop: panah */}
              {m.detailSlug ? (
                <Link
                  to={`/laga/${m.detailSlug}`}
                  aria-label="Lihat detail laga"
                  className="hidden sm:flex sm:col-span-1 justify-end"
                >
                  <div className="w-10 h-10 border border-[#050B14]/20 group-hover:bg-[#E63946] group-hover:border-[#E63946] group-hover:text-white flex items-center justify-center transition-colors">
                    <ArrowRight size={16} />
                  </div>
                </Link>
              ) : (
                <a
                  href="#kontak"
                  aria-label="Ajak bertanding"
                  className="hidden sm:flex sm:col-span-1 justify-end"
                >
                  <div className="w-10 h-10 border border-[#050B14]/20 group-hover:bg-[#E63946] group-hover:border-[#E63946] group-hover:text-white flex items-center justify-center transition-colors">
                    <ArrowRight size={16} />
                  </div>
                </a>
              )}

              {/* Mobile: tombol lebar */}
              {m.detailSlug ? (
                <Link
                  to={`/laga/${m.detailSlug}`}
                  className="sm:hidden inline-flex items-center justify-center gap-2 bg-[#050B14] text-white px-4 py-2.5 text-xs font-bold tracking-wider"
                >
                  LINEUP & SKUAD <ArrowRight size={14} />
                </Link>
              ) : (
                <a
                  href="#kontak"
                  className="sm:hidden inline-flex items-center justify-center gap-2 bg-[#050B14] text-white px-4 py-2.5 text-xs font-bold tracking-wider"
                >
                  AJAK BERTANDING <ArrowRight size={14} />
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
